//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
import Utils from "../services/Utils.js";

const BaseAction = class BaseAction {
  constructor(type) {
    if (!type) {
      throw new Error("Type must be set");
    }
    this.id = Utils.generateUuidV4();
    this.type = type;
  }
};

export default BaseAction;
